import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { TicketPackage } from 'interface/TicketPackage';
import { MEDIA_TYPE, TYPE_PACKAGE } from 'utils/data';
import { fetchApiDelete, fetchApiPost, fetchApiPut, fetchApiUploadFile } from 'utils/helper';
import { API_CREAT_TICKET_PACKAGE } from 'config/data';
import { isBuffer } from 'lodash';
import toast, { NotifyType } from 'utils/toast';

const { Option } = Select;

interface FormData {
  initTicketPackage?: TicketPackage,
  onData?: any,
  action?: any,
  onClose?:any,
  ticketType?:any
}
const EditTicket = ({ initTicketPackage, onData, action,onClose,ticketType }: FormData) => {
  const [ticketPackage, setTicketPackage] = useState<Partial<TicketPackage>>({});
  const [form] = Form.useForm();

  useEffect(() => {
    if (action && action === 'edit' && initTicketPackage) {
      form.setFieldsValue(initTicketPackage)
      console.log(initTicketPackage)
    } else {
      form.resetFields()
    }
    setTicketPackage(initTicketPackage || {})
  }, [initTicketPackage, action]);

  const handleSubmit = async (values: any) => {
    if (action !== 'edit') {
      const ticketSend = {...ticketPackage,typeTicket: ticketType?.toUpperCase()}
      const response = await fetchApiPost(API_CREAT_TICKET_PACKAGE, ticketSend, MEDIA_TYPE.JSON)
      if (response !== null) {
        toast(NotifyType.SUCCESS, "Thêm gói thành công!")
        const updateTicket = {...ticketSend,id: response}
        if(onData) {
          onData(updateTicket)
          form.resetFields()
        }
        if(onClose) {
          onClose()
        }
      } else {
        toast(NotifyType.ERROR, "Có lỗi xảy ra!")
      }
    } else {
      const response = await fetchApiPut(`${API_CREAT_TICKET_PACKAGE}/${ticketPackage?.id}`, ticketPackage, MEDIA_TYPE.JSON)
      if (response !== null) {
        toast(NotifyType.SUCCESS, "Cập nhật gói thành công!")
        if(onData) {
          onData(ticketPackage)
        }
        if(onClose) {
          onClose()
        }
      } else {
        toast(NotifyType.ERROR, "Có lỗi xảy ra!")
      }
    }
  };

  const customRequest = async (options: any) => {
    const { onSuccess, onError, file, onProgress } = options;
    const formData = new FormData();
    formData.append('file', file);
    const data: any = await fetchApiUploadFile(formData);
    if (data !== null) {
      console.log(data)
      if (data.status === 1) {
        setTicketPackage({ ...ticketPackage, image: data.url })
        onSuccess(data, file);
      } else {
        toast(NotifyType.ERROR, 'Tải file lên thất bại!');
        onError(new Error('Tải file lên thất bại!'));
        return;
      }
    } else {
      toast(NotifyType.ERROR, 'Tải file lên thất bại!');

    }

  };

  const handleKeyPress = (event: any) => {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);
    if (!charStr.match(/^[0-9.]$/)) {
      event.preventDefault();
    }
  };
  return (
    <div className="max-w-lg mx-auto">
      <div className="bg-white rounded px-8 pb-8 mb-4">
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item
            name="name"
            label="Tên gói"
            rules={[{ required: true, message: 'Vui lòng nhập tên gói!' }]}
          >
            <Input placeholder="Nhập tên gói"
              onChange={(e) => setTicketPackage({ ...ticketPackage, name: e.target.value })} />
          </Form.Item>
          <Form.Item
            name={"description"}
            label="Mô tả">
            <Input placeholder="Nhập mô tả"
              value={ticketPackage?.description}
              onChange={(e) => setTicketPackage({ ...ticketPackage, description: e.target.value })} />
          </Form.Item>
          <Form.Item
            name={"typePackage"}
            label="Loại"
            rules={[{ required: true, message: 'Vui lòng chọn loại!' }]}
          >
            <Select placeholder="Chọn loại" onChange={(value) => setTicketPackage({ ...ticketPackage, typePackage: value })}
              value={ticketPackage?.typePackage}
            >
              <Option value={TYPE_PACKAGE.MONTH}>Gói theo tháng</Option>
              <Option value={TYPE_PACKAGE.TICKET}>Gói theo điểm</Option>
            </Select>
          </Form.Item>
          <div className="flex mb-4">
            {ticketPackage?.typePackage !== TYPE_PACKAGE.TICKET && (
              <Form.Item
                name={"monthNumber"}
                label="Chọn tháng"
                className="w-1/2 pr-2"
                rules={[{ required: true, message: 'Vui lòng chọn tháng!' }]}
              >
                <Select placeholder="Chọn tháng" onChange={(value) => setTicketPackage({ ...ticketPackage, monthNumber: value })}
                  value={ticketPackage?.monthNumber}
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <Option key={i + 1} value={i + 1}>
                      {i + 1} tháng
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            <Form.Item
              name={"ticketQuantity"}
              label="Số điểm"
              className="w-1/2 pl-2"
            >
              <Input placeholder="Điền số điểm" onKeyPress={handleKeyPress}
                value={ticketPackage?.ticketQuantity}
                onChange={(e) => setTicketPackage({ ...ticketPackage, ticketQuantity: e.target.value })} />
            </Form.Item>
          </div>
          <Form.Item
            name={"originalPrice"}
            label="Giá gốc"
            rules={[{ required: true, message: 'Vui lòng nhập giá gốc!' }]}
          >
            <Input placeholder="Nhập số"
              value={ticketPackage?.originalPrice}
              onKeyPress={handleKeyPress}
              onChange={(e) => setTicketPackage({ ...ticketPackage, originalPrice: e.target.value })}
            />
          </Form.Item>
          <Form.Item
            name={"discountPrice"}
            label="Giá sau giảm"
          >
            <Input placeholder="Nhập số" onKeyPress={handleKeyPress}
              value={ticketPackage?.discountPrice}
              onChange={(e) => setTicketPackage({ ...ticketPackage, discountPrice: e.target.value })}
            />
          </Form.Item>
          <Form.Item
            name={"image"}
            label="Tải ảnh lên"
            rules={[{ required: true, message: 'Vui lòng tải ảnh lên!' }]}
          >
            <Upload accept="image/jpeg,image/png" customRequest={customRequest} maxCount={1}>
              <Button icon={<UploadOutlined />}>Tải ảnh lên</Button>
            </Upload>
            {ticketPackage?.image && (
                <img src={ticketPackage?.image} alt="Uploaded" style={{ width: '100%', maxHeight: '300px' }} className='rounded-md mt-2' />
            )}
          </Form.Item>
          <Form.Item>
            <div className="flex justify-end">
              <Button className="mr-2" onClick={onClose}>
                Hủy
              </Button>
              <Button type="primary" htmlType="submit">
                Lưu
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default EditTicket;
